import styled from "styled-components";
import ButtonStyle from "@material-ui/core/Button";
import FormControlLabelStyle from "@material-ui/core/FormControlLabel";
import SwitchStyle from "@material-ui/core/Switch";
import FormGroupStyle from "@material-ui/core/FormGroup";

export const NotificationMenu = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 16px;
`;

export const NotificationContainer = styled.div`
  width: 323px;
  height: 380px;
  position: absolute;
  border-radius: 5px;
  top: calc(44px + 8px);
  left: -100px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2);
  background: ${({ theme }) => theme.container.secondary.background};
  display: flex;
  flex-direction: column;
  &.hidden {
    display: none;
  }
  &:before {
    background: ${({ theme }) => theme.container.secondary.background};
    content: "";
    border-radius: 1px 3px 0 3px;
    display: block;
    width: 13px;
    position: absolute;
    margin: -5px 0 0 66px;
    transform: rotate(45deg);
  }
`;

export const Container = styled.div`
  margin: 0 10px;
  position: relative;

  .buttonContainer {
    button {
      height: 44px;
      &:hover,
      &.active {
        background: ${({ theme }) => theme.navbar.hover.background};
      }
      svg {
        height: 22px;
        color: ${({ theme }) => theme.navbar.text};
      }
    }

    .badge {
      background-color: ${({ theme }) => theme.secondary};
      border: 2px solid ${({ theme }) => theme.navbar.background};
      top: 15px;
      right: 17px;
      min-width: fit-content;
    }
  }
`;

export const Title = styled.h1`
  display: flex;
  align-items: flex-start;
  font-size: 16px;
  font-weight: 400;
  font-family: "Roboto";
  color: #6b6871;
`;

export const Subtitle = styled.h2`
  display: flex;
  margin: 16px 0 16px 0;
  align-items: flex-start;
  font-size: 14px;
  font-weight: 400;
  font-family: "Roboto";
  color: #48454c;
`;

export const Hr = styled.hr`
  width: 100%;
  height: 1px;
  background-color: #eceef6;
  margin-top: 16px;
`;

export const FormGroup = styled(FormGroupStyle)`
`;

export const FormControlLabel = styled(FormControlLabelStyle)`
  && {
    display: flex !important;
    margin-left: 1px;
    .MuiFormControlLabel-label {
        font-weight: 400;
        font-family: "Roboto";
        color: #6b6871;
        gap: 10px;
        font-size: 12px !important;       
    }
  }
`;

export const Switch = styled(SwitchStyle)`
  && {
    .MuiSwitch-thumb {
      background-color: #d1ced7;
    }
    .Mui-checked {
      & + .MuiSwitch-track {
        background-color: #8f5ce7;
      }
      .MuiSwitch-thumb {
        background-color: #7d3ce8;
      }
    }
  }
`;

export const Button = styled(ButtonStyle)`
  && {
    display: flex;
    height: 32px;
    padding: 12px 16px;
    margin: 16px 0;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    border-radius: 2px;
    background: #d1ced7;
    color: #fff;
    
    :hover {
      background: #7d3ce8;
    }
  }
`;

export const LinkError = styled.a`
  && {
    text-decoration: none;
    color: #000;
    font-size: 12px;
  }
`;